<script>
import Mockup1 from "./pages/Mockup1.vue";
import Mockup2 from "./pages/Mockup2.vue";
import State from "./pages/State.vue";
import Search from "./pages/Search.vue";
import Results from "./pages/Results.vue";

let slugs = {
  mockup1: Mockup1,
  mockup2: Mockup2,
  state: State,
  search: Search,
  results: Results,
};

export default {
  name: "AppComp",
  props: ["title", "action", "component"],
  components: { ...slugs },
  data() {
    return {
      current: this.component,
    };
  },
};
</script>

<template>
  <component :is="current" v-bind="{...$props,...$attrs}" />
</template>

<style>
#main {
  margin-top: 0 !important;
}
</style>